// Default layer stack (canvas px coordinates, A4 794×1123).

import { type Layer, CANVAS_W, CANVAS_H } from "./types"

export const createDefaultLayers = (headerColor = "#0f172a"): Layer[] => [
  {
    id: "header",
    type: "header",
    x: 0, y: 0,
    w: CANVAS_W, h: Math.round(CANVAS_H * 0.12),
    rotation: 0, opacity: 1, locked: false,
    headerColor,
  },
  {
    id: "student_info",
    type: "student_info",
    x: 16, y: Math.round(CANVAS_H * 0.13),
    w: Math.round(CANVAS_W * 0.75), h: Math.round(CANVAS_H * 0.10),
    rotation: 0, opacity: 1, locked: false,
    showPhoto: true,
  },
  {
    id: "subject_table_0",
    type: "subject_table",
    x: 16, y: Math.round(CANVAS_H * 0.25),
    w: CANVAS_W - 32, h: Math.round(CANVAS_H * 0.40),
    rotation: 0, opacity: 1, locked: false,
    headerColor,
  },
  {
    id: "grade_key",
    type: "grade_key",
    x: 16, y: Math.round(CANVAS_H * 0.67),
    w: Math.round(CANVAS_W * 0.5), h: Math.round(CANVAS_H * 0.09),
    rotation: 0, opacity: 1, locked: false,
  },
  {
    id: "signatures",
    type: "signatures",
    x: 16, y: Math.round(CANVAS_H * 0.88),
    w: CANVAS_W - 32, h: Math.round(CANVAS_H * 0.07),
    rotation: 0, opacity: 1, locked: false,
  },
]
